import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class isAuthenticatedGuard implements CanActivate, CanActivateChild {
	constructor(private apiService: ApiService,
				private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> { 

		if(this.apiService.isAuthenticated) {
            
            if(route.queryParams.token) {
                const url = new URL(window.location.href);
                url.searchParams.delete("token");
                window.location.href = url.toString();
            }
        
            return true;
        }
		
        else if(route.queryParams.token) {
            return this.apiService.post(`users/authenticate/token`, {token: route.queryParams.token}).pipe(
                map(response => {
                    if(response.authenticated) {
                        this.apiService.me = response;
                        this.apiService.onAuthenticatedSubject.next(response.authenticated);

                        // const url = new URL(window.location.href);
                        // url.searchParams.delete("token");
                        // window.location.href = url.toString();
                    }
                    return response.authenticated;
                })
            )
        }

		else {

			const returnPath = (new URL(state.url, location.origin)).searchParams.get('return');
			this.router.navigate(['/login'], {replaceUrl: true, queryParams: {return: returnPath ?? decodeURIComponent(state.url) }});
			return false;
		}
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> { return this.canActivate(route, state); }
}